import { ButtonHTMLAttributes, forwardRef } from 'react';
import { clsx } from 'clsx';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'accent' | 'ghost';
  size?: 'default' | 'sm' | 'lg' | 'icon';
};

export const Button = forwardRef<HTMLButtonElement, Props>(function Button(
  { className, variant = 'primary', size = 'default', ...props },
  ref,
) {
  const base =
    'inline-flex items-center justify-center rounded-md text-sm font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50 disabled:pointer-events-none';
  const sizes = {
    default: 'h-10 px-4 py-2',
    sm: 'h-8 px-3 text-xs',
    lg: 'h-12 px-6 text-base',
    icon: 'h-9 w-9',
  };
  const variants = {
    primary: 'bg-primary text-primary-foreground hover:-translate-y-0.5 active:scale-95',
    secondary: 'bg-card border border-border text-text-primary hover:-translate-y-0.5',
    accent: 'bg-accent text-white hover:-translate-y-0.5 active:scale-95',
    ghost: 'bg-transparent text-text-primary hover:bg-gray-100 dark:hover:bg-gray-800',
  } as const;
  return (
    <button
      ref={ref}
      className={clsx(base, sizes[size], variants[variant], className)}
      {...props}
    />
  );
});
